export default class UserContactService {
  constructor($http) {
    this.$http = $http;
  }

  get(filter) {
    return this.$http.post(
        '/admin/marketplace/users/find_user_contacts',
        {filter: filter, authenticity_token: window.token}
    );
  }

  save(user_contact) {
    return this.$http({
      method: 'POST',
      url: '/admin/marketplace/users/save_user_contact',
      data: {user_contact: user_contact, authenticity_token: window.token}
    }).then(function(response) {
      return response.data;
    });
  }

  delete(user_contact_id) {
    return this.$http({
      method: 'POST',
      url: '/admin/marketplace/users/delete_user_contact',
      data: {id: user_contact_id, authenticity_token: window.token}
    }).then(function(response) {
      return response.data;
    });
  }

  add_invitation(user_contact_id) {
    return this.$http({
      method: 'POST',
      url: '/admin/marketplace/users/add_invitation',
      data: {user_contact_id: user_contact_id, authenticity_token: window.token}
    }).then(function(response) {
      return response.data;
    });
  }

  delete_invitation(invitation_id) {
    return this.$http({
      method: 'POST',
      url: '/admin/marketplace/users/delete_invitation',
      data: {invitation_id: invitation_id, authenticity_token: window.token}
    }).then(function(response) {
      return response.data;
    });
  }

  update_account_status(account_id, status) {
    return this.$http({
      method: 'POST',
      url: '/admin/marketplace/users/update_account_status',
      data: {account_id: account_id, status: status, authenticity_token: window.token}
    }).then(function(response) {
      return response.data;
    });
  }

  find_similar(email) {
    return this.$http({
      method: 'GET',
      url: '/admin/marketplace/users/find_similar_contacts',
      params: {email: email}
    }).then(function(response) {
      return response.data;
    });
  }

  update_similar_contact(user_contact, account, contact_id) {
    return this.$http({
      method: 'POST',
      url: '/admin/marketplace/users/update_similar_contact',
      data: {user_contact: user_contact, account: account, contact_id: contact_id, status: status, authenticity_token: window.token}
    }).then(function(response) {
      return response.data;
    });
  }

  get_campaign_status_counts() {
    return this.$http.get('/admin/marketplace/users/get_campaign_status_counts');
  }

  mass_update_contact_campaign_status(contacts, campaign_status) {
    return this.$http.post(
        '/admin/marketplace/users/mass_update_contact_campaign_status',
        {contacts: contacts, campaign_status: campaign_status, authenticity_token: window.token}
    );
  }

  get_notifications(user_contact_id) {
    return this.$http.get(
      '/admin/marketplace/users/get_user_contact_notifications',
      {params: {user_contact_id: user_contact_id}}
    );
  }
}

UserContactService.$inject = ['$http'];



// WEBPACK FOOTER //
// ./front/js/admin/services/user-contact.service.js